module.exports = "/lucky-balls/img/bonus_yellow/header_betin.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_betin.png
// module id = 963
// module chunks = 0